import React from 'react';
import './App.css';
import { ApolloProvider } from '@apollo/react-hooks';
import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { HttpLink } from 'apollo-link-http';
import { split } from 'apollo-link';
import { WebSocketLink } from 'apollo-link-ws';
import { getMainDefinition } from 'apollo-utilities';
import { Grid, Typography } from '@material-ui/core';

import Reserves from './Reserves';
import RecentTrades from './RecentTrades';

// Create an http link:
const httpLink = new HttpLink({
  uri: 'https://api.thegraph.com/subgraphs/name/blocklytics/kyberswap'
});

// Create a WebSocket link:
const wsLink = new WebSocketLink({
  uri: `wss://api.thegraph.com/subgraphs/name/blocklytics/kyberswap`,
  options: {
    reconnect: true
  }
});

const link = split(
  // split based on operation type
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription'
    );
  },
  wsLink,
  httpLink,
);

const client = new ApolloClient({
  link,
  cache: new InMemoryCache()
});

function App() {

  return (
    <ApolloProvider client={client}>
      <div className="App">
        <header className="App-header">
          <Typography variant="h6">
            KyberSwap Swaps
          </Typography>
          <Typography variant="body2">
            Powered by The Graph WebSockets
          </Typography>
        </header>
        <section style={{ maxWidth: 600, margin: '0 auto' }}>
          <RecentTrades />
        </section>
      </div>
    </ApolloProvider>
  );
}

export default App;
